import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';


@Component({
  selector: 'app-delegasi-modal-submit',
  templateUrl: './delegasi-modal-submit.component.html',
  styleUrls: ['./delegasi-modal-submit.component.css']
})
export class DelegasiModalSubmitComponent implements OnInit {

  kw: any;
  load: boolean = false;
  hasilX: any = {};

  cabang: any = '';
  surveyor: any = '';
  group: string = '';
  nama: any = '';
  kelompok: any = '';
  aa: any = [];
  status: any = '';
  is_forever: boolean = false;
  is_foreverText: string = 'N';

  constructor(
    public navParams: NavParams,
    public api: ApiService,
    public util: UtilService
  ) { 
    try {
      this.kw = JSON.parse(this.navParams.data.id);
      console.log('KW', this.kw);
      this.nama = this.navParams.data.nama;
    } catch (error) {
      this.util.showToast('Data Lead_id tidak terparsing', 'danger', 'bottom');
      this.kw = [];
    }

    this.status = this.navParams.data.status;
    this.kelompok = this.navParams.data.kelompok || '';
    this.nama = this.navParams.data.nama || this.nama || '';
    console.log('status', this.status);

    if(this.status == 'survey'){
      try {
        this.aa = JSON.parse(this.navParams.data.listNama);
        console.log('AA', this.aa);
        const surveyorNames = this.aa
          .map(item => item.surveyor_name)
          .filter((value, index, self) => self.indexOf(value) === index);
        this.nama = surveyorNames.join(', ');      
      } catch (error) {
        this.aa = [];
      }
    }else if(this.status == 'kelompok'){
      try {
        this.aa = JSON.parse(this.navParams.data.listNama);
        console.log('AA', this.aa);
        const surveyorNames = this.aa
          .map(item => item.collector_name)
          .filter((value, index, self) => self.indexOf(value) === index);
        this.nama = surveyorNames.join(', ');      
      } catch (error) {
        this.aa = [];
      }
    }else if(this.status == 'pindahKelompok'){
      try {
        this.aa = JSON.parse(this.navParams.data.listNama || '[]');
        console.log('AA', this.aa);
        if (Array.isArray(this.aa) && this.aa.length > 0) {
          const groupNames = this.aa
            .map(item => item.group_name)
            .filter((value, index, self) => self.indexOf(value) === index);
          if (groupNames.length) {
            this.nama = groupNames.join(', ');
          }
        }
      } catch (error) {
        this.aa = [];
      }
    }
  }

  ngOnInit(): void {
    let p  = localStorage.getItem('user') || '';
    if(p !== ''){
      this.cabang = JSON.parse(p).branch_name;
    }
  }

  update(){
    if(this.status == 'survey'){
      this.updateSurvey();
    }else if(this.status == 'kelompok'){
      this.updateKelompok();
    }else if(this.status == 'delegasiKelompok'){
      this.updateDelegasiKelompok();
    }else if(this.status == 'pindahKelompok'){
      this.updatePindahKelompok();
    }
  }

  gantiForever(){
    if(this.is_forever == true){
      this.is_foreverText = 'Y';
    }else{
      this.is_foreverText = 'N'
    }
    console.log('is_forever', this.is_forever);
  }

  updatePindahKelompok() {
    if(!this.load){
    if(this.group == ''){
      this.util.showToast('Group Wajib Diisi','danger','bottom');
      return false;
    }
    this.load = true;
    let param = {
      new_group: false,
      lead_id: this.kw,
      move_group_to: this.group
    }
    this.api.put('backoffice/delegasi/pindah-kelompok', param)
      .subscribe((data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message, 'success', 'bottom');
        this.api.dismissData('', 'confirm');
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
    }
  }

  updateDelegasiKelompok() {
    if(!this.load){
    if(this.surveyor == ''){
      this.util.showToast('Surveyor Wajib Diisi','danger','bottom');
      return false;
    }
    this.load = true;
    let param = {
      lead_group_id: this.kw,
      delegasi_to: this.surveyor
    }
    this.api.put('backoffice/delegasi/delegasi-kelompok', param)
      .subscribe((data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message, 'success', 'bottom');
        this.api.dismissData('', 'confirm');
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
    }
  }

  updateKelompok() {
    if(!this.load){
    if(this.surveyor == ''){
      this.util.showToast('Kolektor Wajib Diisi','danger','bottom');
      return false;
    }
    this.load = true;
    let param = {
      ids: this.kw,
      delegasi_to: this.surveyor,
      is_forever: this.is_foreverText
    }
    this.api.put('backoffice/delegasi/collection/kelompok', param)
      .subscribe((data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message,'success','bottom');
        this.api.dismissData('', 'confirm');
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
    }
  }

  updateSurvey() {
    if(!this.load){
    if(this.surveyor == ''){
      this.util.showToast('Surveyor Wajib Diisi','danger','bottom');
      return false;
    }
    this.load = true;
    let param = {
      leads_id: this.kw,
      delegasi_to: this.surveyor
    }
    this.api.put('backoffice/delegasi/survey', param)
      .subscribe((data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message,'success','bottom');
        this.api.dismissData('', 'confirm');
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
    }
  }

  handleSelection(selectedValue: string, model: any) {
    if (model == 'surveyor') {
      this.surveyor = selectedValue;
    } else if (model == 'group') {
      this.group = selectedValue;
    }
  }

  batal(){
    this.api.dismiss();
  }


}
